import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PerfectSkeleton } from '../../../../../components/Common/perfect-skeleton/perfect-skeleton.component';
import { THEME } from '../../../../../themes';
import STRING_KEYS from '../../../../../language/keys';
import {
  PerfectButtonHoverVariants,
  PerfectButtonSize,
} from '../../../../../components/Common/Buttons/perfect-base-button/perfect-base-button.enums';
import { usePermissionCheck } from '../../../../../hooks/use-permissions.hook';
import { PERMISSIONS } from '../../../../../consts/permissions.const';
import Tooltip from '../../../../../components/tooltip/tooltip.component';
import {
  Container,
  BodyTitle,
  BodyHeaderRightContainer,
  CreatePositionButton,
  CreatePositionButtonIcon,
  VerticalDivider,
} from '../homepage-body-header.styled';
import { HomepageBodyHeaderSkeletonProps } from './homepage-body-header-skeleton';

const UsersSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.TINY};
`;

const UsersAvatars = styled.div`
  display: flex;
  gap: ${THEME.SPACING.TINO};
`;

const HomepageBodyHeaderSkeleton = ({
  createPositionButtonClickHandler,
  isPositionCreateLoading = false,
}: HomepageBodyHeaderSkeletonProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const { allowed: allowedCreatePosition } = usePermissionCheck([
    PERMISSIONS.position.createAll,
  ]);

  const renderCreatePositionButton = () => {
    const Button = (
      <CreatePositionButton
        StartIcon={ CreatePositionButtonIcon }
        onClick={ createPositionButtonClickHandler }
        size={ PerfectButtonSize.Large }
        hoverVariant={ PerfectButtonHoverVariants.Grow }
        isLoading={ isPositionCreateLoading }
        disabled={ !allowedCreatePosition }
      >
        {translate(STRING_KEYS.CREATE_POSITION.CREATE_POSITION_OPEN_BUTTON)}
      </CreatePositionButton>
    );
    if (!allowedCreatePosition) {
      return (
        <Tooltip
          content={ translate(
            STRING_KEYS.CREATE_POSITION.CREATE_POSITION_OPEN_BUTTON_TOOLTIP,
          ) }
        >
          {Button}
        </Tooltip>
      );
    }

    return Button;
  };

  return (
    <Container>
      <BodyTitle>
        {translate(STRING_KEYS.HOMEPAGE.POSITIONS_TITLE)}
      </BodyTitle>
      <BodyHeaderRightContainer>
        <UsersSection>
          <PerfectSkeleton width={ 80 } height={ 16 } variant="text" />
          <UsersAvatars>
            <PerfectSkeleton width={ 32 } height={ 32 } variant="circular" />
            <PerfectSkeleton width={ 32 } height={ 32 } variant="circular" />
            <PerfectSkeleton width={ 32 } height={ 32 } variant="circular" />
          </UsersAvatars>
        </UsersSection>

        <VerticalDivider />

        <PerfectSkeleton width={ 200 } height={ 8 } variant="rounded" />

        {renderCreatePositionButton()}
      </BodyHeaderRightContainer>
    </Container>
  );
};

export default HomepageBodyHeaderSkeleton;
